import styled from 'styled-components';

export const PopoverInfoWrapper = styled.div`
  margin: 14px;
  min-width: 300px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > div:last-child {
    cursor: pointer;
  }
`;
